import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_cfg_fiscal_period_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  system: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  guid_login: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_cfg_fiscal_period_event_RowClass
  implements bl_fi_cfg_fiscal_period_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  system: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  guid_login: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
